import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SmCheckFilter} from "./sm.filter";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../srvs/lookup";
import {AlertService} from "../services/alert.service";

@Component({
  selector: 'micro-smcs',
  templateUrl: './smcs.component.html'
})
export class SmChecksComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns:string[] = ['name','lastRun','serviceType','negId','neId','status'];
  filter:SmCheckFilter = new SmCheckFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              public lookupService:LookupService,
              private alertService: AlertService) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.paginator.pageIndex = 0;
      this.reload();
    });
  }

  ngOnInit() {
    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 20))
      ;

    this.http.get(`${this.env.e.url}/sm`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.setNextRun();
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  public schedule(smCheck) {
    this.http.post(`${this.env.e.url}/sm/${smCheck.id}/schedule`, {}).subscribe(
      data => {
        this.alertService.info(`Scheduled ${smCheck.name}`)
        this.reload();
      }
    );
  }

  setNextRun() {
    for (let check of this.dataSource.data) {
      this.http.get(`${this.env.e.url}/sm/${check.id}/next`).subscribe(
        data => {
          check.nextExecutionTime = data as any;
        }
      );
    }
  }
}
